import React, { memo } from 'react'
import NumericFormat, { INumericFormatProps } from 'transfix-ui/components/NumericFormat'
import uuid from 'uuid/v4'

type TPickedProp =
  | 'value'
  | 'prefix'
  | 'placeholder'
  | 'id'
  | 'decimalScale'
  | 'className'
  | 'renderText'

export interface ICurrencyProps extends Pick<INumericFormatProps, TPickedProp> {
  value?: number
  label?: string
  datatest?: string
}

const getDefaultDecimalScale = (value: number) => {
  return Number.isInteger(value) ? 0 : 2
}

export const Currency = memo<ICurrencyProps>(
  ({
    value,
    prefix = '$',
    placeholder = '$',
    label,
    id = uuid(),
    datatest = 'currency',
    decimalScale = value ? getDefaultDecimalScale(value) : undefined,
    className,
    renderText,
  }) => (
    <>
      {label && <label htmlFor={id}>{label}</label>}
      <NumericFormat
        renderText={renderText}
        className={className}
        value={value ?? placeholder}
        displayType='text'
        thousandSeparator
        valueIsNumericString
        allowLeadingZeros
        placeholder={placeholder}
        id={id}
        data-test={datatest}
        prefix={prefix}
        decimalScale={decimalScale}
        fixedDecimalScale
      />
    </>
  )
)
